// NumberInput.tsx
import { initial } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface InputFeildProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: number | '';
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  key?: string;
  uniqueKey?: string;
  maxLength?: number;
}

const InputContainer = styled.div<{ inputType?: string }>`
  position: relative;
  max-width: max-content;

  ${({ inputType }) =>
    inputType === 'attributes' &&
    `
    // &::before {
    //   content: '';
    //   position: absolute;
    //   top: 6px;
    //   right: 0px;
    //   width: 20px;
    //   height: 20px;
    //   font-size: 14px;
    //   content: "%";
    //   padding-right:12px;
    // }
  `}
`;

const StyledInput = styled.input<{ inputType?: string; inputLength: number }>`
   width:100%;
  padding: 8px 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
  color: ${({ theme }) => theme.playerColor};
  background: ${({ theme }) => theme.notificationTitleColor};
  font-feature-settings: 'liga' off, 'clig' off;

  /* DM-Mono/Title/Small */
  font-family: "DM Mono";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 100% */
  text-transform: uppercase;

  &:focus {
    outline: none;
    /* Keep the border color same even when focused */
    border-color: ${({ theme }) => theme.playerDataBorder};
    box-shadow: none; /* Optionally remove box-shadow on focus */
  }  
`;

const InputFeild: React.FC<InputFeildProps> = ({ value: initialValue, onChange, type, maxLength, ...props }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState<number | string>(initialValue);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if(maxLength && maxLength > 0 ){
      if(newValue.length <= maxLength){
        setValue(newValue);  // Update local state

        // Call the onChange prop if provided
        if (onChange) {
          onChange(event);
        }
      }
    }else{

      setValue(newValue);  // Update local state

      // Call the onChange prop if provided
      if (onChange) {
        onChange(event);
      }

    }
  };

  const handleFocus = () => {
    if (value === 0) {
      setValue('');  // Clear the default value
    }
  };

  const handleBlur = () => {
    if (value === '') {
      setValue(0);  // Reset to 0 if no value entered
    }
  };

  // useEffect(() => {
  //   if (inputRef.current) {
  //     inputRef.current.value = value !== '' ? value.toString() : '';
  //   }
  // }, [initialValue]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  const inputLength = value.toString().length;

  return (
    <InputContainer inputType={type}>
      <StyledInput
        //autoFocus
        ref={inputRef}
        type="number"
        value={value}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        onFocus={handleFocus}
        onBlur={handleBlur}
        inputType={type}
        inputLength={inputLength}
        maxLength={ maxLength }

        {...props}
      />
    </InputContainer>
  );
};

export default InputFeild;
